import { render, staticRenderFns } from "./insure-motor-detail-form.vue?vue&type=template&id=73b363ca&scoped=true&"
import script from "./insure-motor-detail-form.vue?vue&type=script&lang=js&"
export * from "./insure-motor-detail-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b363ca",
  null
  
)

export default component.exports